import { render } from "./InstallView.vue?vue&type=template&id=2fa9159d"
import script from "./InstallView.vue?vue&type=script&lang=js"
export * from "./InstallView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__